import React, { useRef, useState } from "react";
import "./OurHistory.css";

import carImageSoon from '../../img/team-logos/black-background-logo.png';
import carImage2026 from '../../img/homepage/Image Dec 7, 2025, 11_08_59 AM.png'; 
import carImage2025 from '../../img/homepage/P1017405-Picsart.png';  /*P1017405-Picsart.png */
import carImage2024 from '../../img/homepage/DSC_9496.jpg'; 
import carImage2023 from '../../img/homepage/DSC00025.JPG';
import carImage2022 from '../../img/homepage/DSCF7134.jpg'; 
import carImage2021 from '../../img/homepage/EV2 - 2021.jpg';
import carImage2020 from '../../img/homepage/EV1 - 2020.jpg'; 
import carImage2015 from '../../img/team-logos/white-background-logo.png';




const timelineData = [
  { year: "2015", desc: "MAC FORMULA ELECTRIC IS FOUNDED", image: carImage2015 },
  { year: "2020", desc: "MAC EV1 ATTENDS VIRTUAL COMPETITION", image: carImage2020 },
  { year: "2021", desc: "MAC EV2 ATTENDS VIRTUAL COMPETITION", image: carImage2021 },
  { year: "2022", desc: "MAC EV3 ATTENDS 1st OFFICIAL COMPETITION", image: carImage2022 },
  { year: "2023", desc: "MAC EV4 ATTENDS 2nd OFFICIAL COMPETITION", image: carImage2023 },
  { year: "2024", desc: "MAC EV5 ATTENDS 3rd OFFICIAL COMPETITION", image: carImage2024 },
  { year: "2025", desc: "MACFE-25 ATTENDS 4th OFFICIAL COMPETITION", image: carImage2025 },
  { year: "2026*", desc: "MACFE-26 WILL ATTEND ITS 5th OFFICIAL COMPETITION", image: carImage2026 },
  { year: "SOON", desc: "See you in Michigan!", image: carImageSoon}
];

export default function OurHistory() {
  const timelineRef = useRef(null);
  const [page, setPage] = useState(0);

  const itemsPerPage = window.innerWidth < 768 ? 1 : 3;
  const totalPages = Math.ceil(timelineData.length / itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) {
      setPage(page + 1);
      timelineRef.current.style.transform = `translateX(-${(page + 1) * 100}%)`;
    }
  };

  const handlePrev = () => {
    if (page > 0) {
      setPage(page - 1);
      timelineRef.current.style.transform = `translateX(-${(page - 1) * 100}%)`;
    }
  };
  const pageChunks = [];
    for (let i = 0; i < timelineData.length; i += itemsPerPage) {
    pageChunks.push(timelineData.slice(i, i + itemsPerPage));
    }


  return (
    <section className="history-section">
      <div className="history-title-row">
        <div className="history-line left"></div>
        <h2 className="history-title">Our History</h2>
        <div className="history-line right"></div>
      </div>

      <div className="timeline-container">
        {page > 0 && (
          <button className="arrow left-arrow" onClick={handlePrev}></button>
        )}
        
        <div className="timeline-viewport">
            {/* Timeline line moved OUTSIDE wrapper */}
            <div className="timeline-line" />
            
            {/* CHUNK THE DATA INTO PAGES */}
<div className="timeline-wrapper" ref={timelineRef}>
  {pageChunks.map((chunk, pageIndex) => (
    <div className="timeline-page" key={pageIndex}>
      
      {/* LINE THAT APPEARS PER PAGE */}
      <div className="timeline-line" />

      {/* ITEMS ON THIS PAGE */}
      {chunk.map((item, i) => (
        <div className="timeline-item" key={i}>
          <div className="circle">
            <img src={item.image} alt={item.year} />
          </div>
          <h3 className="year">{item.year}</h3>
          <p className="desc">{item.desc}</p>
        </div>
        ))}
        </div>
    ))}
    </div>

        </div>

        
        {page < totalPages - 1 && (
          <button className="arrow right-arrow" onClick={handleNext}></button>
        )}
        
      </div>
      
    </section>
  );
}
